import { ButtonDescription } from './button-description.component.js';
export { ButtonDescription } from './button-description.component.js';
import { ButtonSuperBreak } from './button-super-break.component.js';
export { ButtonSuperBreak } from './button-super-break.component.js';
import { Button } from './button.component.js';
export { Button } from './button.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';

const TextButton = deprecatedComponent({
    displayName: 'TextButton',
    root: Button,
    description: 'Use Button component Instead'
});
const TextButtonDescription = deprecatedComponent({
    displayName: 'TextButtonDescription',
    root: ButtonDescription,
    description: 'Use ButtonDescription component Instead'
});
const TextButtonSuperBreak = deprecatedComponent({
    displayName: 'TextButtonSuperBreak',
    root: ButtonSuperBreak,
    description: 'Use ButtonSuperBreak component Instead'
}) /* PLOP_COMPONENT_EXPORT_IN_INDEX */ ;

export { TextButton, TextButtonDescription, TextButtonSuperBreak };
